const getHeaders = () => {
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${auth.access_token}`,
  };
};

const checkResponse = (r) => {
  if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
  return r;
};

export const apiGet = (path) =>
  fetch(`${window.ENV.API_URL}/${path}`, { headers: getHeaders() })
    .then(checkResponse)
    .then((r) => r.json());

export const apiPost = (path, body) =>
  fetch(`${window.ENV.API_URL}/${path}`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(body),
  })
    .then(checkResponse)
    .then((r) => r.json());

export const apiPatch = (path, body) =>
  fetch(`${window.ENV.API_URL}/${path}`, {
    method: "PATCH",
    headers: getHeaders(),
    body: JSON.stringify(body),
  })
    .then(checkResponse)
    .then((r) => r.json());

export const apiDelete = (path) =>
  fetch(`${window.ENV.API_URL}/${path}`, {
    method: "DELETE",
    headers: getHeaders(),
  })
    .then(checkResponse)
    .then((r) => (r.status === 204 ? null : r.json().catch(() => null)));
